import { SelectedCategory } from '@/features/pos/components/ProductCatalog/parts/CategoryBar/types'
import { useCallback, useState } from 'react'

export const useSelectedCategory = (): [SelectedCategory, () => void] => {
    const [selectedCategory, setSelectedCategory] = useState<SelectedCategory>({
        id: undefined,
        subcategoryId: undefined,
    })

    const updateSelectedCategory = useCallback(
        (id?: string, subcategoryId?: string) => setSelectedCategory({ id, subcategoryId }),
        []
    )

    return [selectedCategory, updateSelectedCategory]
}
